import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent, Typography, Button, TextField, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { recaptchaSite } from '../config';

declare global {
    interface Window {
        grecaptcha: any;
    }
}

const TireRatingLogin = () => {
    const [telefonnummer, setTelefonnummer] = useState('');
    const [registreringsnummer, setRegistreringsnummer] = useState('');
    const [recaptchaOk, setRecaptchaOk] = useState(false);
    const [recaptchaError, setRecaptchaError] = useState<string | null>(null);
    const recaptchaRef = useRef<HTMLDivElement | null>(null);
    const recaptchaWidgetIdRef = useRef<number | null>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!recaptchaSite) {
                setRecaptchaError('reCAPTCHA-sitekey mangler i miljøvariabler.');
                clearInterval(interval);
                return;
            }

            if (window.grecaptcha && recaptchaRef.current && recaptchaWidgetIdRef.current === null) {
                recaptchaWidgetIdRef.current = window.grecaptcha.render(recaptchaRef.current, {
                    sitekey: recaptchaSite,
                    callback: verifyCallback,
                    'expired-callback': onRecaptchaExpired,
                    'error-callback': onRecaptchaError,
                });
                clearInterval(interval);
            }
        }, 100);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleTelefonnummerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTelefonnummer(event.target.value);
    };
    const navigate = useNavigate();
    const handleRegistreringsnummerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRegistreringsnummer(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const normalizedPhoneNumber = telefonnummer.trim();
        const normalizedRegistrationNumber = registreringsnummer.trim().toUpperCase();
        navigate(`/dekkvurdering/${normalizedPhoneNumber}/${normalizedRegistrationNumber}`);
    };
    type VerifyCallback = (response: string) => void;

    const verifyCallback: VerifyCallback = (response) => {
        setRecaptchaOk(true);
        setRecaptchaError(null);
    };

    const onRecaptchaExpired = () => {
        setRecaptchaOk(false);
    };

    const onRecaptchaError = () => {
        setRecaptchaOk(false);
        setRecaptchaError('reCAPTCHA fikk timeout eller nettverksfeil. Prøv igjen.');
    };

    return (
        <Grid container justifyContent="center" >
            <form onSubmit={handleSubmit}>
                <Grid item xs={12} sm={10}>
                    <Card>
                        <CardContent >
                            <Typography variant='h4' color="text.secondary" gutterBottom>
                                Logg inn for å se vurdering av dine dekk
                            </Typography>

                            <Typography variant="body2" margin={1}>
                                Skriv inn ditt telefonnummer (8 siffer) og kjøretøyets registreringsnummer, og verifiser at du ikke er en robot.
                            </Typography>

                            <TextField margin='normal'
                                label="Telefonnummer"
                                value={telefonnummer}
                                onChange={handleTelefonnummerChange}
                                inputProps={{ maxLength: 8 }}
                                required
                            />
                            <TextField
                                margin='normal'
                                label="Registreringsnummer"
                                value={registreringsnummer}
                                onChange={handleRegistreringsnummerChange}
                                inputProps={{ maxLength: 9 }}
                                required
                            />
                            <div>
                                <div ref={recaptchaRef}></div>
                                <Button type="submit" variant="contained" color="primary" disabled={!recaptchaOk}>
                                    Se vurdering
                                </Button>
                                {recaptchaError && (
                                    <Typography variant="body2" color="error" mt={1}>
                                        {recaptchaError}
                                    </Typography>
                                )}
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </form>
        </Grid>
    );
};

export default TireRatingLogin;
